@if (store()) {
<mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-select disabled [value]="store()?.id" placeholder="Filiale">
            <mat-option [value]="store()!.id">{{store()!.address}}</mat-option>
    </mat-select>
</mat-form-field>
}